import {
  Button,
  DialogActions,
  DialogContent,
  HexIcon,
  Typography,
  Stack,
  tokens,
} from '@cast/design-system';

import { AssignCredentialsDialogHeader } from '../../../_components/AssignCredentialsDialogHeader';

type Props = {
  onClose: () => void;
};

export const SuccessSlide = ({ onClose }: Props) => {
  return (
    <Stack position="relative">
      <AssignCredentialsDialogHeader dismiss={onClose} />
      <DialogContent>
        <Stack direction="row" alignItems="center" gap={8}>
          <HexIcon variant="success" size={40} />
          <Typography variant="h6">
            Kubernetes & cloud security was successfully enabled!
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions
        sx={{ py: 16, borderTop: tokens.theme.border.structural.neutralSubtle }}
      >
        <Button onClick={onClose} variant="secondary" testId="close-button">
          Close
        </Button>
      </DialogActions>
    </Stack>
  );
};
